import { TIIndicatorPointToHighChartIndicatorPointMapper } from '../../mappers/data-point/ti-indicator-point-to-highchart-indicator-point.mapper';
import { TIIndicatorDataModel } from '../../models/data-point/ti-indicator-data.model';
import { IndicatorOptionModel } from '../../models/drop-down-list/indicator-option.model';
import { IComponent } from "../component.interface";
import { TiChartSeriesComponent } from '../ti-chart-series.component';

export class DCIndicatorComponent implements IComponent {
    public id = '';

    private tiChartSeries: TiChartSeriesComponent;

    constructor(tiChartSeries: TiChartSeriesComponent) {
        this.tiChartSeries = tiChartSeries;
    }

    public updateChildrenIndicators(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel, tiIndicatorDataIndex: number, isUpdate: boolean) {
        const dcBottomSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('DC B') >= 0);
        const dcBottom = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('DC B') >= 0);
        const tiIndicatorDcBottomIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators.findIndex((x: TIIndicatorDataModel) => x.name.indexOf('DC B') >= 0);
        if (!dcBottom || !dcBottomSeries || tiIndicatorDcBottomIndex <= - 1) {
            return;
        }

        const dcBottomIndicatorDataPoint = dcBottom.points?.length ? dcBottom.points[dcBottom.points.length - 1] : null;
        if (!dcBottomIndicatorDataPoint) {
            return;
        }

        const needZone = dcBottom.needHighChartZone(dcBottomSeries.type);
        if (isUpdate) {
            const lastChartBar = dcBottomSeries.points.find((x: any) => x.x == dcBottomIndicatorDataPoint.xValue);
            const tiIndicatorDataPointIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorDcBottomIndex].points.findIndex(x => x.xValue == dcBottomIndicatorDataPoint.xValue);
            // update to main ti indicator data points
            if (tiIndicatorDataPointIndex > -1) {
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorDcBottomIndex].points[tiIndicatorDataPointIndex] = dcBottomIndicatorDataPoint;
            }

            if (!lastChartBar) {
                const dataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorDcBottomIndex], indicatorOption.value, true);
                dcBottomSeries.setData(dataPoints.points, true, false, true);
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorDcBottomIndex].zones = dataPoints.zones;
            } else {
                const lastHighChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, dcBottomIndicatorDataPoint, dcBottom);
                lastChartBar.update(lastHighChartDataPoint, false);

                if (needZone) {
                    const existingZoneIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].zones.findIndex((x: any) => x.value == dcBottomIndicatorDataPoint.xValue);
                    if (existingZoneIndex > -1) {
                        const lastHighChartZoneDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(dcBottomIndicatorDataPoint, this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
                        this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorDcBottomIndex].zones[existingZoneIndex] = lastHighChartZoneDataPoint;
                    }
                }
            }
        } else {
            const highChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, dcBottomIndicatorDataPoint, dcBottom);
            dcBottomSeries.addPoint(highChartDataPoint, false);
            this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorDcBottomIndex].points.push(dcBottomIndicatorDataPoint);
            if (needZone) {
                const lastHighChartZoneDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(dcBottomIndicatorDataPoint, this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorDcBottomIndex].zones.push(lastHighChartZoneDataPoint);
            }
        }
        
        if (needZone) {
            dcBottomSeries.update({
                zones: this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorDcBottomIndex].zones,
                type: dcBottomSeries.type == 'line' ? 'line' : 'spline',
                zoneAxis: 'x'
            },);
        }
    }

    public updateHistoryChildrenIndicators(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel, firstPoint: number) {
        const dcBottomSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('DC B') >= 0);
        const dcBottom = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('DC B') >= 0);
        if (!dcBottom || !dcBottomSeries) {
            return;
        }

        const needZone = dcBottom.needHighChartZone(dcBottomSeries.type);
        for (let j = dcBottom.points.length - 1; j > 0; j--) {
            const indicatorDataPoint = dcBottom.points[j];
            if (indicatorDataPoint.timestamp && indicatorDataPoint.xValue < firstPoint) {
                const point = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, indicatorDataPoint, dcBottom);
                dcBottomSeries.addPoint(point, false);
                if (needZone) {
                    const zonePoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(indicatorDataPoint, indicatorData);
                    dcBottom.zones.unshift(zonePoint);
                }
            }
        }
        if (needZone) {
            dcBottomSeries?.update({
                zones: dcBottom.zones,
                type: dcBottomSeries.type == 'line' ? 'line' : 'spline',
                zoneAxis: 'x'
            }, false);
        }
    }
}